import "./status-message.css";
import { useTranslation } from "react-i18next";
import type { ThinkingBannerKind } from "@/types";
import { CHAT_PRIMARY } from "@/lib/chatTheme";

type Properties = {
    isRecording: boolean;
    isThinking?: boolean;
    thinkingBanner?: ThinkingBannerKind;
};

const barStyle = (i: number) => ({
    backgroundColor: CHAT_PRIMARY,
    animation: `barHeight${(i % 3) + 1} 1s ease-in-out infinite`,
    animationDelay: `${i * 0.1}s`,
});

export default function StatusMessage({
    isRecording,
    isThinking = false,
    thinkingBanner = "thinking",
}: Properties) {
    const { t } = useTranslation();
    if (isThinking) {
        return (
            <div className="flex items-end" aria-label={thinkingBanner === "searching" ? "searching" : "thinking"}>
                <div className="relative h-6 w-6 overflow-hidden" style={{ marginBottom: "5.5px" }}>
                    <div className="absolute inset-0 flex items-end justify-around">
                        {[...Array(4)].map((_, i) => (
                            <div
                                key={i}
                                className="w-1 rounded-full opacity-80"
                                style={barStyle(i)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    if (!isRecording) {
        return <p className="text max-md:mt-1 max-md:text-sm mt-2 text-[#666]">{t("status.notRecordingMessage")}</p>;
    }

    return (
        <div className="flex items-end">
            <div className="relative h-6 w-6 overflow-hidden" style={{marginBottom: '5.5px'}}>
                <div className="absolute inset-0 flex items-end justify-around">
                    {[...Array(4)].map((_, i) => (
                        <div
                            key={i}
                            className="w-1 rounded-full opacity-80"
                            style={barStyle(i)}
                        />
                    ))}
                </div>
            </div>
            <p className="text ml-2 mt-6">{t("status.conversationInProgress")}</p>
        </div>
    );
}
